import ActionMenu from "@ovh-ui/oui-action-menu";
import Autocomplete from "@ovh-ui/oui-autocomplete";
import BackButton from "@ovh-ui/oui-back-button";
import Button from "@ovh-ui/oui-button";
import Calendar from "@ovh-ui/oui-calendar";
import Checkbox from "@ovh-ui/oui-checkbox";
import Chips from "@ovh-ui/oui-chips";
import Clipboard from "@ovh-ui/oui-clipboard";
import Collapsible from "@ovh-ui/oui-collapsible";
import Criteria from "@ovh-ui/oui-criteria";
import CriteriaAdder from "@ovh-ui/oui-criteria-adder";
import CriteriaContainer from "@ovh-ui/oui-criteria-container";
import Datagrid from "@ovh-ui/oui-datagrid";
import Dropdown from "@ovh-ui/oui-dropdown";
import DualList from "@ovh-ui/oui-dual-list";
import Field from "@ovh-ui/oui-field";
import File from "@ovh-ui/oui-file";
import FormActions from "@ovh-ui/oui-form-actions";
import GuideMenu from "@ovh-ui/oui-guide-menu";
import HeaderTabs from "@ovh-ui/oui-header-tabs";
import InlineAdder from "@ovh-ui/oui-inline-adder";
import Message from "@ovh-ui/oui-message";
import Modal from "@ovh-ui/oui-modal";
import Navbar from "@ovh-ui/oui-navbar";
import Numeric from "@ovh-ui/oui-numeric";
import PageHeader from "@ovh-ui/oui-page-header";
import Pagination from "@ovh-ui/oui-pagination";
import Password from "@ovh-ui/oui-password";
import Popover from "@ovh-ui/oui-popover";
import Progress from "@ovh-ui/oui-progress";
import Radio from "@ovh-ui/oui-radio";
import Search from "@ovh-ui/oui-search";
import Select from "@ovh-ui/oui-select";
import SelectPicker from "@ovh-ui/oui-select-picker";
import Skeleton from "@ovh-ui/oui-skeleton";
import Slideshow from "@ovh-ui/oui-slideshow";
import Spinner from "@ovh-ui/oui-spinner";
import Stepper from "@ovh-ui/oui-stepper";
import Switch from "@ovh-ui/oui-switch";
import Tabs from "@ovh-ui/oui-tabs";
import Textarea from "@ovh-ui/oui-textarea";
import Tile from "@ovh-ui/oui-tile";
import Timepicker from "@ovh-ui/oui-timepicker";
import Tooltip from "@ovh-ui/oui-tooltip";

export default angular
    .module("oui", [
        ActionMenu,
        Autocomplete,
        BackButton,
        Button,
        Calendar,
        Checkbox,
        Chips,
        Clipboard,
        Collapsible,
        Criteria,
        CriteriaAdder, // Deprecated: Suppport only for old use
        CriteriaContainer, // Deprecated: Suppport only for old use
        Datagrid,
        Dropdown,
        DualList,
        Field,
        File,
        FormActions,
        GuideMenu,
        HeaderTabs,
        InlineAdder,
        Message,
        Modal,
        Navbar,
        Numeric,
        PageHeader,
        Pagination,
        Password,
        Popover,
        Progress,
        Radio,
        Search,
        Select,
        SelectPicker,
        Skeleton,
        Slideshow,
        Spinner,
        Stepper,
        Switch,
        Tabs,
        Textarea,
        Tile,
        Timepicker,
        Tooltip
    ])
    .name;
